export function convertNanoToMilliSeconds(valueNs: number): number {
  return valueNs * 1e-6
}

export function convertMilliToSeconds(valueNs: number): number {
  return valueNs * 1e-3
}
